import { S3Client, S3ClientConfig, PutObjectCommand, PutObjectRequest } from '@aws-sdk/client-s3';
import { AwsBucketConfig } from './libs/types/types';

class AwsS3Bucket {
  public client: S3Client;
  private config: AwsBucketConfig;
  constructor(config: AwsBucketConfig) {
    this.config = config;
    this.client = new S3Client(this.awsConfig);
  }

  public uploadFile = async (fileContent: File, bucketName: string, keyName: string) => {
    const params: PutObjectRequest = {
      Bucket: bucketName,
      Key: keyName,
      Body: fileContent,
    };

    return await this.client.send(new PutObjectCommand(params));
  };

  private get awsConfig(): S3ClientConfig {
    return {
      region: this.config.region,
      credentials: {
        accessKeyId: this.config.accessKeyId,
        secretAccessKey: this.config.secretAccessKey,
      },
    };
  }
}

export { AwsS3Bucket };
